import { makeSearchable } from './arrays.ts';

export const MLBTeams = makeSearchable([
  {
    slug: 'arizona-diamondbacks',
    name: 'Diamondbacks',
    fullName: 'Arizona Diamondbacks',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-arizona-diamondbacks.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-ari.svg',
    teamStyleGuidePrimaryColor: '#A71930',
  },
  {
    slug: 'atlanta-braves',
    name: 'Braves',
    fullName: 'Atlanta Braves',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-atlanta-braves.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-atl.svg',
    teamStyleGuidePrimaryColor: '#BA0C2F',
  },
  {
    slug: 'boston-red-sox',
    name: 'Red Sox',
    fullName: 'Boston Red Sox',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-boston-red-sox.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-bos.svg',
    teamStyleGuidePrimaryColor: '#BD3039',
  },
  {
    slug: 'baltimore-orioles',
    name: 'Orioles',
    fullName: 'Baltimore Orioles',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-baltimore-orioles.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-bal.svg',
    teamStyleGuidePrimaryColor: '#DF4601',
  },
  {
    slug: 'chicago-cubs',
    name: 'Cubs',
    fullName: 'Chicago Cubs',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-chicago-cubs.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-chc.svg',
    teamStyleGuidePrimaryColor: '#0E3386',
  },
  {
    slug: 'chicago-white-sox',
    name: 'White Sox',
    fullName: 'Chicago White Sox',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-chicago-white-sox.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cws.svg',
    teamStyleGuidePrimaryColor: '#C4CED4',
  },
  {
    slug: 'cincinnati-reds',
    name: 'Reds',
    fullName: 'Cincinnati Reds',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-cincinnati-reds.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cin.svg',
    teamStyleGuidePrimaryColor: '#C6011F',
  },
  {
    slug: 'cleveland-guardians',
    name: 'Guardians',
    fullName: 'Cleveland Guardians',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-cleveland-guardians.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cle.svg',
    teamStyleGuidePrimaryColor: '#E31937',
  },
  {
    slug: 'colorado-rockies',
    name: 'Rockies',
    fullName: 'Colorado Rockies',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-colorado-rockies.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-col.svg',
    teamStyleGuidePrimaryColor: '#33006F',
  },
  {
    slug: 'detroit-tigers',
    name: 'Tigers',
    fullName: 'Detroit Tigers',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-detroit-tigers.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-det.svg',
    teamStyleGuidePrimaryColor: '#182D55',
  },
  {
    slug: 'houston-astros',
    name: 'Astros',
    fullName: 'Houston Astros',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-houston-astros.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-hou.svg',
    teamStyleGuidePrimaryColor: '#EB6E1F',
  },
  {
    slug: 'kansas-city-royals',
    name: 'Royals',
    fullName: 'Kansas City Royals',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-kansas-city-royals.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-kc.svg',
    teamStyleGuidePrimaryColor: '#004687',
  },
  {
    slug: 'los-angeles-angels',
    name: 'Angels',
    fullName: 'Los Angeles Angels',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-los-angeles-angels.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-laa.svg',
    teamStyleGuidePrimaryColor: '#BA0021',
  },
  {
    slug: 'los-angeles-dodgers',
    name: 'Dodgers',
    fullName: 'Los Angeles Dodgers',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-los-angeles-dodgers.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-lad.svg',
    teamStyleGuidePrimaryColor: '#005A9C',
  },
  {
    slug: 'miami-marlins',
    name: 'Marlins',
    fullName: 'Miami Marlins',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-miami-marlins.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-mia.svg',
    teamStyleGuidePrimaryColor: '#00A3E0',
  },
  {
    slug: 'milwaukee-brewers',
    name: 'Brewers',
    fullName: 'Milwaukee Brewers',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-milwaukee-brewers.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-mil.svg',
    teamStyleGuidePrimaryColor: '#FFC72C',
  },
  {
    slug: 'minnesota-twins',
    name: 'Twins',
    fullName: 'Minnesota Twins',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-minnesota-twins.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-min.svg',
    teamStyleGuidePrimaryColor: '#D31145',
  },
  {
    slug: 'new-york-mets',
    name: 'Mets',
    fullName: 'New York Mets',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-new-york-mets.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-nym.svg',
    teamStyleGuidePrimaryColor: '#002D72',
  },
  {
    slug: 'new-york-yankees',
    name: 'Yankees',
    fullName: 'New York Yankees',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-new-york-yankees.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-nyy.svg',
    teamStyleGuidePrimaryColor: '#132448',
  },
  {
    slug: 'oakland-athletics',
    name: 'Athletics',
    fullName: 'Oakland Athletics',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-oakland-athletics.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-oak.svg',
    teamStyleGuidePrimaryColor: '#003831',
  },
  {
    slug: 'philadelphia-phillies',
    name: 'Phillies',
    fullName: 'Philadelphia Phillies',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-philadelphia-phillies.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-phi.svg',
    teamStyleGuidePrimaryColor: '#E81828',
  },
  {
    slug: 'pittsburgh-pirates',
    name: 'Pirates',
    fullName: 'Pittsburgh Pirates',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-pittsburgh-pirates.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-pit.svg',
    teamStyleGuidePrimaryColor: '#FDB827',
  },
  {
    slug: 'san-diego-padres',
    name: 'Padres',
    fullName: 'San Diego Padres',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-san-diego-padres.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sd.svg',
    teamStyleGuidePrimaryColor: '#2F241D',
  },
  {
    slug: 'san-francisco-giants',
    name: 'Giants',
    fullName: 'San Francisco Giants',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-san-francisco-giants.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sf.svg',
    teamStyleGuidePrimaryColor: '#FD5A1E',
  },
  {
    slug: 'seattle-mariners',
    name: 'Mariners',
    fullName: 'Seattle Mariners',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-seattle-mariners.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sea.svg',
    teamStyleGuidePrimaryColor: '#005C5C',
  },
  {
    slug: 'st-louis-cardinals',
    name: 'Cardinals',
    fullName: 'St. Louis Cardinals',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-st-louis-cardinals.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-stl.svg',
    teamStyleGuidePrimaryColor: '#BE0A14',
  },
  {
    slug: 'tampa-bay-rays',
    name: 'Rays',
    fullName: 'Tampa Bay Rays',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-tampa-bay-rays.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tb.svg',
    teamStyleGuidePrimaryColor: '#092C5C',
  },
  {
    slug: 'texas-rangers',
    name: 'Rangers',
    fullName: 'Texas Rangers',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-texas-rangers.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tex.svg',
    teamStyleGuidePrimaryColor: '#003278',
  },

  {
    slug: 'toronto-blue-jays',
    name: 'Blue Jays',
    fullName: 'Toronto Blue Jays',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-toronto-blue-jays.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tor.svg',
    teamStyleGuidePrimaryColor: '#134A8E',
  },
  {
    slug: 'washington-nationals',
    name: 'Nationals',
    fullName: 'Washington Nationals',
    svgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-washington-nationals.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-was.svg',
    teamStyleGuidePrimaryColor: '#AB0003',
  },
] as const);

export const MLBClubs = makeSearchable([
  {
    slug: 'arizona-diamondbacks',
    name: 'Arizona Diamondbacks',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-arizona-diamondbacks.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-ari.svg',
    styleGuideColor: '#A71930',
  },
  {
    slug: 'atlanta-braves',
    name: 'Atlanta Braves',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-atlanta-braves.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-atl.svg',
    styleGuideColor: '#BA0C2F',
  },
  {
    slug: 'boston-red-sox',
    name: 'Boston Red Sox',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-boston-red-sox.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-bos.svg',
    styleGuideColor: '#BD3039',
  },
  {
    slug: 'baltimore-orioles',
    name: 'Baltimore Orioles',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-baltimore-orioles.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-bal.svg',
    styleGuideColor: '#DF4601',
  },
  {
    slug: 'chicago-cubs',
    name: 'Chicago Cubs',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-chicago-cubs.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-chc.svg',
    styleGuideColor: '#0E3386',
  },
  {
    slug: 'chicago-white-sox',
    name: 'Chicago White Sox',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-chicago-white-sox.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cws.svg',
    styleGuideColor: '#C4CED4',
  },
  {
    slug: 'cincinnati-reds',
    name: 'Cincinnati Reds',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-cincinnati-reds.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cin.svg',
    styleGuideColor: '#C6011F',
  },
  {
    slug: 'cleveland-guardians',
    name: 'Cleveland Guardians',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-cleveland-guardians.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-cle.svg',
    styleGuideColor: '#E31937',
  },
  {
    slug: 'colorado-rockies',
    name: 'Colorado Rockies',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-colorado-rockies.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-col.svg',
    styleGuideColor: '#33006F',
  },
  {
    slug: 'detroit-tigers',
    name: 'Detroit Tigers',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-detroit-tigers.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-det.svg',
    styleGuideColor: '#182D55',
  },
  {
    slug: 'houston-astros',
    name: 'Houston Astros',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-houston-astros.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-hou.svg',
    styleGuideColor: '#EB6E1F',
  },
  {
    slug: 'kansas-city-royals',
    name: 'Kansas City Royals',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-kansas-city-royals.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-kc.svg',
    styleGuideColor: '#004687',
  },
  {
    slug: 'los-angeles-angels',
    name: 'Los Angeles Angels',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-los-angeles-angels.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-laa.svg',
    styleGuideColor: '#BA0021',
  },
  {
    slug: 'los-angeles-dodgers',
    name: 'Los Angeles Dodgers',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-los-angeles-dodgers.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-lad.svg',
    styleGuideColor: '#005A9C',
  },
  {
    slug: 'miami-marlins',
    name: 'Miami Marlins',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-miami-marlins.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-mia.svg',
    styleGuideColor: '#00A3E0',
  },
  {
    slug: 'milwaukee-brewers',
    name: 'Milwaukee Brewers',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-milwaukee-brewers.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-mil.svg',
    styleGuideColor: '#FFC72C',
  },
  {
    slug: 'minnesota-twins',
    name: 'Minnesota Twins',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-minnesota-twins.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-min.svg',
    styleGuideColor: '#D31145',
  },
  {
    slug: 'new-york-mets',
    name: 'New York Mets',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-new-york-mets.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-nym.svg',
    styleGuideColor: '#002D72',
  },
  {
    slug: 'new-york-yankees',
    name: 'New York Yankees',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-new-york-yankees.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-nyy.svg',
    styleGuideColor: '#132448',
  },
  {
    slug: 'oakland-athletics',
    name: 'Oakland Athletics',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-oakland-athletics.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-oak.svg',
    styleGuideColor: '#003831',
  },
  {
    slug: 'philadelphia-phillies',
    name: 'Philadelphia Phillies',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-philadelphia-phillies.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-phi.svg',
    styleGuideColor: '#E81828',
  },
  {
    slug: 'pittsburgh-pirates',
    name: 'Pittsburgh Pirates',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-pittsburgh-pirates.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-pit.svg',
    styleGuideColor: '#FDB827',
  },
  {
    slug: 'san-diego-padres',
    name: 'San Diego Padres',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-san-diego-padres.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sd.svg',
    styleGuideColor: '#2F241D',
  },
  {
    slug: 'san-francisco-giants',
    name: 'San Francisco Giants',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-san-francisco-giants.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sf.svg',
    styleGuideColor: '#FD5A1E',
  },
  {
    slug: 'seattle-mariners',
    name: 'Seattle Mariners',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-seattle-mariners.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-sea.svg',
    styleGuideColor: '#005C5C',
  },
  {
    slug: 'st-louis-cardinals',
    name: 'St. Louis Cardinals',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-st-louis-cardinals.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-stl.svg',
    styleGuideColor: '#BE0A14',
  },
  {
    slug: 'tampa-bay-rays',
    name: 'Tampa Bay Rays',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-tampa-bay-rays.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tb.svg',
    styleGuideColor: '#092C5C',
  },
  {
    slug: 'texas-rangers',
    name: 'Texas Rangers',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-texas-rangers.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tex.svg',
    styleGuideColor: '#003278',
  },

  {
    slug: 'toronto-blue-jays',
    name: 'Toronto Blue Jays',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-toronto-blue-jays.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-tor.svg',
    styleGuideColor: '#134A8E',
  },
  {
    slug: 'washington-nationals',
    name: 'Washington Nationals',
    pictureUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-headwear-mark-washington-nationals.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/baseball/logos/logo-monochrome-team-was.svg',
    styleGuideColor: '#AB0003',
  },
] as const);
